import {useTranslation} from "react-i18next";
import {TxtTitles} from "../../../../../../../../helpers/breadCrumbs";
import {ListInformationElement} from "./ListInformationElement";
import React from "react";
import {Button} from "../../../../../../../../components/ui/Button";
import {Colors} from "../../../../../../../../components/theme";

const AddTotalCostsFooter = ({data, saveHandler}) => {
    const { t } = useTranslation()

    const fields = [
        {
            title: "",
            content: <Button
                    className='me-4 pull-right'
                    variant='round'
                    style={{ backgroundColor: Colors.green }}
                    name='Save'
                    onClick={saveHandler}>
                    {t("common.button.save")}
                </Button>,
            widthLimit: '43%'
        },
        {
            title: <TxtTitles>{t('events.summary.client_costs')}</TxtTitles>,
            content: parseFloat(data.totalClientCost).toFixed(2),
            widthLimit: '27%',
            style: { margin: '0 auto', textAlign: 'center' }
        },
        {
            title: <TxtTitles>{t('events.summary.estro_costs')}</TxtTitles>,
            content: parseFloat(data.totalEstroCost,).toFixed(2),
            widthLimit: '27%',
            style: { margin: '0 auto', textAlign: 'center' }
        },
        {
            widthLimit: '3%'
        },
    ];

    return <ListInformationElement fields={fields} styleMainDiv={{borderTop:'1px dashed black',paddingTop:'5px'}}/>;
}

export default AddTotalCostsFooter;
